<!--
  Copyright 2020 The Ground Authors.

  Licensed under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License.
  You may obtain a copy of the License at

      https://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.
-->

<mat-list *ngIf="job$ | async as job">
  <!--
    TODO: create separate component for job as a header instead of
    using JobListItem here.
  -->
  <ground-job-list-item
    [job]="job"
    [actionsType]="jobListItemActionsType.BACK"
  ></ground-job-list-item>
</mat-list>
<div *ngIf="submissionForm" class="submission">
  <h3>Add/edit submission</h3>
  <form [formGroup]="submissionForm" (ngSubmit)="onSave()" autocomplete="off">
    <div *ngFor="let task of submissionTasks">
      <div class="task-result">
        <!-- Text task -->
        <div *ngIf="task.type == taskTypes.TEXT">
          <mat-form-field appearance="fill">
            <mat-label class="task-label" [attr.for]="task.id">
              {{ task.label }}
            </mat-label>
            <input
              matInput
              [formControlName]="task.id"
              [id]="task.id"
              [required]="task.required"
            />
          </mat-form-field>
        </div>
        <div *ngIf="task.type == taskTypes.NUMBER">
          <mat-form-field appearance="fill">
            <input
              type="number"
              matInput
              [formControlName]="task.id"
              [id]="task.id"
            />
          </mat-form-field>
        </div>

        <!-- Multiple choice task -->
        <div
          *ngIf="task.type == taskTypes.MULTIPLE_CHOICE"
          class="multiple-choice-task"
        >
          <!-- Radio button task -->
          <mat-label
            [class.asterix--after]="task.required"
            [attr.for]="task.id"
            [id]="task.id"
          >
            {{ task.label }}
          </mat-label>
          <br />
          <mat-radio-group
            [id]="task.id"
            [formControlName]="task.id"
            *ngIf="task.multipleChoice?.cardinality == cardinality.SELECT_ONE"
            [required]="task.required"
          >
            <mat-radio-button
              *ngFor="let option of task.multipleChoice?.options; let i = index"
              [value]="option.id"
            >
              {{ option.label }}
            </mat-radio-button>
          </mat-radio-group>

          <!-- Checkbox task -->
          <div
            *ngIf="
              task.multipleChoice?.cardinality == cardinality.SELECT_MULTIPLE
            "
          >
            <mat-checkbox
              [formControlName]="option.id"
              *ngFor="let option of task.multipleChoice?.options"
              [value]="option.id"
            >
              {{ option.label }}
            </mat-checkbox>
          </div>
        </div>
      </div>
    </div>
    <div style="float: right">
      <button mat-stroked-button (click)="onCancel()" type="button">
        Cancel
      </button>
      <button
        mat-flat-button
        color="primary"
        type="submit"
        style="margin-left: 8px"
        [disabled]="!submissionForm.valid"
      >
        Save
      </button>
    </div>
  </form>
</div>
